import styled from "styled-components";
import colors from "../../../../../utils/colors";

const StyledLabel = styled.div`
  label {
    font-family: FyranSans-Book, sans-serif;
    font-size: 1rem;
    margin-bottom: 0.5em;
    color: ${colors.GRAY};
    display: block;
  }
  width: 100%;
  margin-bottom: 2.25rem !important;

  ${props =>
    props.tight &&
    `
    margin-bottom: 1rem !important;
  `}

  ${props =>
    props.half &&
    `
    width: calc(50% - 0.625rem);
  `}

  ${props =>
    props.inline &&
    `
    width: auto;
    label {
      margin-right: .5em;
      display: inline;
    }
  `}
`;

export default StyledLabel;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledLabel.js